import { Controller } from "@hotwired/stimulus";
import { get } from '@rails/request.js';

// Connects to data-controller="search-pacientes-guardia"
export default class extends Controller {
  static targets = ['searchInput', 'allGuardiaCheckbox', 'obraSocial', 'desde', 'hasta'];
  static values = {
    url: String
  }

  onClickPerformSearch(event) {
    event.preventDefault();
    let obraSocialValue = null;

    if (this.hasObraSocialTarget && this.obraSocialTarget.value && this.obraSocialTarget.value !== 'Obra social') {
      obraSocialValue = this.obraSocialTarget.value;
    }

    get(this.urlValue, {
      responseKind: 'turbo-stream',
      query: {
        q_guardia: this.hasSearchInputTarget ? this.searchInputTarget.value || null : null,
        all_guardia: this.hasAllGuardiaCheckboxTarget ? this.allGuardiaCheckboxTarget.checked : false,
        obra_social_guardia: obraSocialValue,
        desde_guardia: this.hasDesdeTarget ? this.desdeTarget.value || null : null,
        hasta_guardia: this.hasHastaTarget ? this.hastaTarget.value || null : null,
        tab: 'guardia'
      }
    })
  }
}
